/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plum_Glad_Ram_SpinInputs */

const en_plum_glad_ram_spin = /** @type {(inputs: Plum_Glad_Ram_SpinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All selected users and all their data will be removed from this organization.`)
};

const de_plum_glad_ram_spin = /** @type {(inputs: Plum_Glad_Ram_SpinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Nutzer werden damit aus dieser Organisation entfernt und alle Daten entfernt.`)
};

/**
* | output |
* | --- |
* | "All selected users and all their data will be removed from this organization." |
*
* @param {Plum_Glad_Ram_SpinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plum_glad_ram_spin = /** @type {((inputs?: Plum_Glad_Ram_SpinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plum_Glad_Ram_SpinInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plum_glad_ram_spin(inputs)
	return de_plum_glad_ram_spin(inputs)
});